import React from "react";
import { NavItem } from "@/monarch/rules/hubRedesign/types";
import { ElementClicked } from "@/hooks/eventing/types/redventures.usertracking.v3.ElementClicked";
import { ElementType } from "@/constants/tagular/main";
import useElementEvents from "@/hooks/eventing/useElementEvents";

interface NavLinkProps {
  item: NavItem;
  index: number;
}

export const StickyNavDesktopLink = ({ item, index }: NavLinkProps) => {
  const webElement: ElementClicked["webElement"] = {
    elementType: ElementType.Link,
    htmlId: item.htmlId,
    location: "degree-hub-toc-desktop",
    position: `${index + 1}`,
    text: item.text,
  };

  const { elementClicked } = useElementEvents({
    webElement,
  });

  return (
    <a
      key={item.text}
      href={`${item.anchorLink}`}
      onClick={() => elementClicked()}
      className="text-white opacity-80 hover:opacity-100 hover:text-white underline elm-p3"
    >
      {item.text}
    </a>
  );
};
